<template>
  <ranking-main>
    <ranking-header activeMenu="10xIncome" slot="rankingNavigation" />
    <loading-container :loading="form.rankLoading">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-7">
            <div>{{ $t('ranking.intro_10x')}}</div>
          </div>
          <div class="col-md-5">
            <loading-container :loading="form.rankSectorLoading">
              <el-select class="w-100" v-model="searchSector" clearable :placeholder="$t('sector_types.title')"
                @change="gotoFilter()">
                <el-option v-for="item in filterOptions" :key="item.value" :label="item.text" :value="item.value">
                  <span>{{ item.text }}</span>
                  <span class="right-align">
                    <i :class="getSectorIcons(`${item.value}`)"></i>
                  </span>
                </el-option>
              </el-select>
            </loading-container>
            <el-select class="mt-2 w-100" v-model="searchType" clearable :placeholder="$t('business_types.title')"
              @change="gotoFilter()">
              <el-option v-for="item in filterBusinessTypeOptions" :key="item.code" :label="item.name"
                :value="item.code">
                <span>{{ item.name }}</span>
                <span class="right-align">
                  <i :class="getTypeIcons(`${item.code}`)"></i>
                </span>
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <loading-container :loading="form.rankFilterLoading">
        <div v-if="rank.length > 0" class="padding-2">
          <div v-for="(item, index) in rank" :class="index % 2 == 0 ? 'odd' : 'even'" :key="item.code">
            <h5 class="m-t-20">
              <span class="badge bg-danger ms-auto mr-2">{{ index + 1 }}</span>
              <a class="d-inline waves-effect" @click="() => linkToStockInfo(item.code, false)">
                <span>{{ item.code }} - </span>
              </a>
              <span class="font-12" v-if="item.type">
                <IconTooltip :iconClass="getTypeIcons(`${item.type}`)" :text="getBusinessTypeText(`${item.type}`)"/>
              </span>
              <span class="font-12">
                | <IconTooltip :iconClass="getSectorIcons(`${item.sector_code}`)" :text="getSectorText(`${item.sector_code}`)"/>
                | {{ item.industry }}
              </span>
              <span class="font-12" v-if="item.vn30"> - <span class="text-warning bg-danger">VN30</span></span>
              <span v-if="item.warning">
                <IconTooltip iconClass="text-danger fas fa-exclamation-triangle" :text="$t('messages.warning_state')" />
              </span>
              <a class="d-inline waves-effect waves-dark right-align text-blue"
                @click="() => linkToStockInfo(item.code, true)">
                <i class="mdi mdi-launch"></i>
              </a>
            </h5>
            <div class="row">
              <div class="col-md-7">
                <div class="progress">
                  <div class="progress-bar bg-success active progress-bar-striped" role="progressbar"
                    :style="{ width: mosValueFilter(item.value)}">
                    {{ mosValueFilter(item.value) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row m-t-20 m-l-10">
          {{ $t('messages.filter_no_result') }}
        </div>
      </loading-container>
    </loading-container>
  </ranking-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import LoadingContainer from '@/components/Misc/LoadingContainer';
import RankingHeader from '../components/Header';
import RankingMain from '../components/Main';
import InputSelect from "@/components/Form/InputSelect";
import common from "@/libs/common";
import IconTooltip from '../../../components/Common/IconTooltip.vue';

export default {
  name: 'Rank10xIncome',
  components: {
    LoadingContainer,
    IconTooltip,
    RankingHeader,
    RankingMain,
    InputSelect
  },
  beforeMount() {
    this.getRankingByType({type: 1, params: {}});
    if (!this.sectors.length) {
      this.getRankingSectors();
    }
  },
  data() {
    return {
      searchSector: '',
      searchType: '',
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      form: "ranking/form",
      rank: "ranking/rank",
      search: "ranking/search",
      sectors: "ranking/sectors",
    }),
    filterOptions() {
      return this.sectors;
    },
    filterBusinessTypeOptions() {
      return common.getTypeOptions();
    },
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    currentUser() {
      return this.user || {};
    },
  },
  methods: {
    ...mapActions({
      setDefaultCode: "configuration/setDefaultCode",
      getRanking: "ranking/getRanking",
      getRankingByType: "ranking/getRankingByType",
      getRankingSectors: "ranking/getSectors",
    }),
    getTypeIcons(code) {
      return common.getTypeIcons(code);
    },
    getSectorIcons(code) {
      return common.getSectorIcons(code);
    },
    getSectorText(code) {
      return common.getSectorText(code);
    },
    getBusinessTypeText(code) {
      return common.getBusinessTypeText(code);
    },
    mosValueFilter(value) {
      return _.round(value * 100, 1) + '%';
    },
    linkToStockInfo(code, isNewtab) {
      this.setDefaultCode(code);
      
      if(isNewtab) {
        let routeData = this.$router.resolve({name: 'overview', params: { codeId: code } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({ name: 'overview', params: { codeId: code } }).catch(()=>{});
      }
    },
    gotoFilter() {
      const filter = {};
      if (this.searchSector) {
        filter['sectors'] = [this.searchSector]
      }
      if (this.searchType) {
        filter['types'] = [this.searchType]
      }
      this.getRankingByType({type: 1, params: filter});
    },
  },
};
</script>
<style scoped>
.progress-bar {
  color: #000;
}
</style>